<template></template>

<script setup>
import { onBeforeMount, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import store from '@/store'

const router = useRouter()
const authStore = useStore()

const loginURL = import.meta.env.VITE_LOGIN_URL

async function signIn() {
  const params = new URLSearchParams(location.search)
  const email = params.get('email')
  const cabinetId = params.get('cabinetId')
  const roleCode = params.get('roleCode')
  const accessToken = params.get('accessToken')
  const refreshToken = params.get('refreshToken')
  const is_superadmin = params.get('is_superadmin');
  const is_superadmin_roles = params.get('is_superadmin_roles');
  const is_superadmin_id = params.get('is_superadmin_id');
  localStorage.removeItem('is_superadmin');
  localStorage.removeItem('is_superadmin_roles');
  localStorage.removeItem('is_superadmin_id');

  if (!email || !accessToken || !refreshToken) {
    location = loginURL
    return
  }

  const payload = {
    email,
    accessToken,
    refreshToken,
    cabinetId,
    roleCode,
  }

  if (is_superadmin) {
    localStorage.setItem('is_superadmin', 'true');
  }

  if (is_superadmin_roles) {
    localStorage.setItem('is_superadmin_roles', is_superadmin_roles);
  }

  if (is_superadmin_id) {
    localStorage.setItem('is_superadmin_id', is_superadmin_id);
  }
  
  authStore
    .dispatch('signIn', payload)
    .then(async (response) => {
      const status = response.data.type
      if (status === 'signin') {
        await authStore.dispatch('getAuthUser').catch(() => {})
        if (!response.data?.showAgreements) {
          location = '/';
        } else {
          location = '/agreements';
        }
      } else if (status === 'finish_register') {
        router.push({
          name: 'FinishSignup',
        })
      }
    })
      .catch((error) => {
        location = loginURL
      })
}

onBeforeMount(signIn)
</script>
